import React from 'react';
import { Product, getProductsWithMultipleVersions } from '../data/products';

interface VersionSelectorProps {
  onProductSelect: (productId: string, version: string) => void;
}

export const VersionSelector: React.FC<VersionSelectorProps> = ({ onProductSelect }) => {
  const multiVersionProducts = getProductsWithMultipleVersions();

  return (
    <div className="bg-white rounded-xl p-5 shadow-lg border border-gray-200">
      <h3 className="text-sm font-bold text-purple-600 mb-4 uppercase tracking-wide flex items-center gap-2">
        <span>🔄</span> Version Comparison
      </h3>

      <div className="space-y-4">
        {multiVersionProducts.map(product => (
          <div key={product.id} className="border border-gray-200 rounded-lg p-3 hover:border-purple-300 transition-all">
            <div className="font-semibold text-sm text-gray-800 mb-2">
              {product.name}
            </div>
            <div className="space-y-1">
              {product.versions.map(version => (
                <button
                  key={version.version}
                  onClick={() => onProductSelect(product.id, version.version)}
                  className={`w-full text-left px-3 py-2 rounded text-xs transition-all ${
                    version.isLatest
                      ? 'bg-gradient-to-r from-purple-100 to-indigo-100 text-purple-700 font-semibold border border-purple-200'
                      : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span>{version.version}</span>
                    {version.isLatest && (
                      <span className="px-2 py-0.5 bg-purple-500 text-white rounded-full text-[10px] font-bold">
                        LATEST
                      </span>
                    )}
                  </div>
                  {version.changes.length > 0 && (
                    <div className="text-[10px] text-gray-500 mt-1">
                      {version.changes.length} changes
                    </div>
                  )}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4 p-3 bg-purple-50 rounded-lg border border-purple-100">
        <div className="text-xs text-purple-700 font-semibold mb-1">💡 Pro Tip</div>
        <div className="text-xs text-gray-600">
          Click on any version to compare with the latest version
        </div>
      </div>
    </div>
  );
};
